<template>
  <app-admin>
    <div class="container content">
      <loader ref="mainLoader"/>
      <div class="flex-between">
        <h1>Участники</h1>
        <router-link :to="{name: 'NewPlayer'}" v-if="players.length != 0">
          <div class="btn">
            <font-awesome-icon icon="user-plus"/>
            Добавить нового участника
          </div>
        </router-link>
      </div>
      <div class="no-players" v-show="players.length == 0 && filter.length == 0 && resultCount==0">
        <div class="text">
          У Вас пока нет ни одного созданного участника.
          <br>
          Добавьте нового участника
        </div>
        <router-link :to="{name: 'NewPlayer'}">
          <div class="btn btn-lg">
            <font-awesome-icon icon="user-plus"/>
            Добавить нового участника
          </div>
        </router-link>
      </div>
      <div class="players" v-show="!(players.length == 0 && filter.length == 0 && resultCount==0)">
        <app-search @change="handleFilter" debounce="500"/>
        <div class="relative">
          <loader ref="loader"/>

          <table cellspacing="0" cellpadding="0" class="main-table">
            <thead>
            <tr>
              <th class="index">№</th>
              <th class="fio">ФИО участника</th>
              <th>Группа</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="players.length == 0">
              <td colspan="5" class="text-center">
                <em>Участников не найдено.</em>
              </td>
            </tr>
            <tr v-for="(player, index) in players" :key="player.id">
              <td>{{(itemsPerPage*(currentPage-1)) + index+1}}</td>

              <router-link :to="{ name: 'Player', params: { id: player.id }}" tag="td" class="hover">
                {{player.last_name}} {{player.first_name}} {{player.middle_name}}
              </router-link>

              <td class="groups">
                <div v-if="player.group_set.length != 0">
                  <player-dropdown-list :array="player.group_set"/>
                </div>
                <div v-else>без группы</div>
              </td>
              <td style="white-space: nowrap">
                <router-link :to="{ name: 'EditPlayer', params: { id: player.id }}">
                  <font-awesome-icon icon="edit"
                                     v-tooltip="{content: 'Редактировать ФИО участника', class: 'tooltip-custom'}"/>
                </router-link>

                <font-awesome-icon icon="trash-alt" v-tooltip="{content: 'Удалить участника', class: 'tooltip-custom'}"
                                   @click="showModalRemovePlayer(player)"/>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <pagination @change="setPage" :itemsPerPage="itemsPerPage" :resultCount="resultCount"/>
      </div>

      <transition name="fade">
        <confirm-modal v-if='confirmModal' @confirm='deletePlayer' @cancel="cancelDeletePlayer">
          Вы действительно хотите удалить участника <br>
          {{playerToRemove.last_name}} {{playerToRemove.first_name}} {{playerToRemove.middle_name}}?
        </confirm-modal>
      </transition>
    </div>
  </app-admin>
</template>

<script>
  import ConfirmModal from '@/components/modal/ConfirmModal'
  import DropdownList from '@/components/players/DropdownList'
  import PlayersService from '@/services/PlayersService'

  export default {
    name: 'Players',
    components: {
      'confirm-modal': ConfirmModal,
      'player-dropdown-list': DropdownList
    },
    data () {
      return {
        confirmModal: false,
        playerToRemove: {},
        filter: '',
        currentPage: 1,
        itemsPerPage: 10,
        resultCount: 0,
        players: []
      }
    },
    computed: {},
    methods: {
      showModalRemovePlayer (player) {
        this.playerToRemove = player
        this.confirmModal = true
      },
      deletePlayer () {
        PlayersService.deletePlayer(this.playerToRemove.id).then(
          (response) => {
            this.players.splice(this.players.indexOf(this.playerToRemove), 1)
          }
        )
        this.confirmModal = false
      },
      cancelDeletePlayer () {
        this.confirmModal = false
      },
      handleFilter: function (filter) {
        this.filter = filter
        this.currentPage = 1
        this.getPlayers()
      },
      setPage (pageNumber) {
        this.currentPage = pageNumber
        this.getPlayers()
      },
      getPlayers () {
        this.$refs.loader.show()
        PlayersService.getPlayers(this.currentPage, this.itemsPerPage, this.filter).then(
          (response) => {
            this.players = response.results
            this.$refs.loader.hide()
            this.$refs.mainLoader.hide()
            this.resultCount = response.count
          }
        )
      }
    },
    mounted () {
      this.$refs.mainLoader.show()
      this.getPlayers()
    }
  }
</script>

<style scoped lang="scss">
  .players {
    font-weight: 300;
  }
</style>



// WEBPACK FOOTER //
// src/pages/admin/players/Players.vue